import React__default from 'react';
import styles from './List.scss.mjs';

function List({
  attributes,
  children,
  type
}) {
  const Tag = type === 'unordered' ? 'ul' : 'ol';
  return /*#__PURE__*/React__default.createElement(Tag, Object.assign({}, attributes, {
    className: styles.List
  }), children);
}

export { List };
